import styles from './BaseSearchSuggests.module.scss';
import Loader from 'components/Generic/Loader';

type Props = {
  id?: string;
  messageText: string;
  suggestions: any;
  className?: string;
  onSelect: (suggestion) => void;
  onSelectFilterOptionWithArrow: (payload) => void;
  onSuggestOptionFocusHandler: (index) => void;
  isFetching: boolean;
};

const BaseSearchSuggests = ({
  id = '',
  className = '',
  suggestions,
  onSelectFilterOptionWithArrow,
  onSuggestOptionFocusHandler,
  messageText,
  onSelect,
  isFetching,
}: Props) => {
  const handleKeyDown = (e, idx, suggestion) => {
    e.preventDefault();
    if (e.code === 'ArrowDown') {
      onSelectFilterOptionWithArrow({
        direction: 'down',
        idx,
      });
    } else if (e.code === 'ArrowUp') {
      onSelectFilterOptionWithArrow({
        direction: 'up',
        idx,
      });
    } else if (e.code === 'Enter') {
      onSelect(suggestion);
    }
  };

  return (
    <div
      className={`${styles.search__suggests} ${className} ${
        messageText ? styles.search__suggestsWMessage : ''
      }`}
      id={id}
    >
      {isFetching ? (
        <Loader size="16" className="mx-auto d-flex my-2" loading={isFetching} />
      ) : (
        <div className="search__suggests__content" role="listbox">
          {messageText && (
            <p
              className={`${styles.search__suggests__message} section-header-small p-2`}
              aria-hidden="true"
            >
              {messageText}
            </p>
          )}
          <p className="sr-only" />
          {suggestions.length !== 0 && (
            <ul>
              {suggestions.map((suggestion, idx) => (
                <li key={suggestion.name} role="option">
                  <button
                    id={`suggestion-${idx}`}
                    type="button"
                    aria-hidden="true"
                    className="field-dropdown-expanded-label btn btn-naked p-2 suggest-option"
                    onClick={() => onSelect(suggestion)}
                    onKeyDown={(e) => handleKeyDown(e, idx, suggestion)}
                    onFocus={() => onSuggestOptionFocusHandler(idx)}
                  >
                    <strong>{suggestion.name}</strong>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default BaseSearchSuggests;
